import createIcon from '../../createIcon';

/**
 * @component @name NetworkWifi2Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMy41QzcuMzEgMy41IDMuMDcgNS40IDAgOC40OEwxMiAyMC41TDI0IDguNDhDMjAuOTMgNS40IDE2LjY5IDMuNSAxMiAzLjVaTTE2Ljc4IDEyLjg4QzE1LjQgMTIgMTMuNzYgMTEuNSAxMiAxMS41QzEwLjI0IDExLjUgOC42IDEyIDcuMjIgMTIuODhMMi45MiA4LjU4QzUuNTEgNi41OCA4LjY3IDUuNSAxMiA1LjVDMTUuMzMgNS41IDE4LjQ5IDYuNTggMjEuMDggOC41N0wxNi43OCAxMi44OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NetworkWifi2Bar = createIcon('NetworkWifi2Bar', [
  [
    'path',
    {
      d: 'M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5ZM16.78 12.88C15.4 12 13.76 11.5 12 11.5C10.24 11.5 8.6 12 7.22 12.88L2.92 8.58C5.51 6.58 8.67 5.5 12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L16.78 12.88Z',
      key: '1kxhuh',
    },
  ],
]);

export default NetworkWifi2Bar;
